import * as moment from "moment"
import * as lookup from "../../../../../static/lookup.json"
import * as dataLayerLookup from "../../../../../static/dataLayerEventTrigger.json"
import { getAge } from "../../helperFunctions"
import { removeLeadingZeros } from "../../../../shared/functions"
const CryptoJS = require('crypto-js');

export function gainDataLayer (allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState)  {
    console.log(journeyState)
    let journeyId = journeyState?.journeyIdFromStrapi
    let allJourneyData = allJourneyDataResponse
    let lastDataLayerElement
    let dynamicEvent
    var clientId
    let FundSFINArray = []
    let FundSFIN
    let FundAllocationArray = []
    let FundAllocation
    let FundValue
    try {
      let cookies = document.cookie
      let cookieArray = cookies.split(";")
      if (cookieArray && cookieArray.length) {
          let gaTagCookie = cookieArray.find(element => {
          if (element.includes("_ga=")) {
            return element.split(".")
          }
        })
        if (gaTagCookie) {
            let gaTagCookieSplit = gaTagCookie.split(".")
            if (gaTagCookieSplit && gaTagCookieSplit.length) {
                clientId = `${gaTagCookieSplit[gaTagCookieSplit.length - 2]}.${
                    gaTagCookieSplit[gaTagCookieSplit.length - 1]
                }`
          } else {
            clientId = ""
        }
        } else {
          clientId = ""
        }
    } else {
        clientId = ""
    }
    } catch (err) {
      console.log("Error geting google tag", "err")
    }
    window.dataLayer = window.dataLayer || [];
    if(window.dataLayer.length){
        lastDataLayerElement = window.dataLayer[window.dataLayer.length -1]
    }else{
        lastDataLayerElement = {}
    }

    if(e === "previous"){
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.previousButtonEvent?.eventName 
    }else if(e === "proceed"){
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.proceedButtonEvent?.eventName
    }else if(e === "landing"){
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.landingPageEvent?.eventName
    }else {
        console.log(dataLayerLookup)
        dynamicEvent = dataLayerLookup?.[journeyId]?.[sectionId]?.componentKeyEvent?.[componentFormControlKey]?.eventName
    }
    let pageNameHaveSource = window.location.href?.includes("source")
    if(dynamicEvent === "GAI_Buy_PersonalDetail_Landed" && !pageNameHaveSource){
        return 
    }
    let spouseCover = allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" ? "YES" : allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "01" ? "NO" : ""

    let paymentOption 
    if(allJourneyData?.basicDetails?.paymentOption){
        if(allJourneyData?.basicDetails?.paymentOption === "N"){
            paymentOption = "paynow"
        }else {
            paymentOption = "paylater"
        }
    }else if(allJourneyData?.paymentStep){
        if(allJourneyData?.paymentStep === "N"){
            paymentOption = "paynow"
        }else {
            paymentOption = "paylater"
        }
    }else{
        paymentOption = ""
    }

    let funds = allJourneyData?.productDetails?.fundDetails?.funds
    if(funds && funds.length){
      funds.forEach(fund => {
        FundSFINArray.push(fund?.sfinNo)
        FundAllocationArray.push(fund?.allocationPercent)
      });
      FundSFIN = FundSFINArray.join('|')
      FundAllocation = FundAllocationArray.join('|')
    }
    let biJson = journeyState?.biJson ? journeyState?.biJson : null
    console.log(dataLayerLookup?.[journeyId]?.[sectionId]);
    console.log(dataLayerLookup?.[journeyId]?.[sectionId]?.sectionName);

    const urlParams = new URLSearchParams("?" + window?.location?.href?.split("?")?.[1])
    let sourceParameter
    if(urlParams){
         sourceParameter = urlParams.get("source")
    }

    let nomineeRelationship = 'n/a'
    if (allJourneyData?.nominees?.[0]?.relationshipWithLa){
        if (allJourneyData?.nominees?.[0]?.gender === "M"){
            nomineeRelationship = lookup?.nomineeRelationshipWithLAMale?.[0][allJourneyData?.nominees?.[0]?.relationshipWithLa]
        }else{
            nomineeRelationship = lookup?.nomineeRelationshipWithLAFemale?.[0][allJourneyData?.nominees?.[0]?.relationshipWithLa]
        }
    }else{
        if (journeyState?.nomineeDataSecond?.gender === "M"){
            nomineeRelationship = lookup?.nomineeRelationshipWithLAMale?.[0][journeyState?.nomineeDataSecond?.relationship]
        }else if (journeyState?.nomineeDataSecond?.gender){
            nomineeRelationship = lookup?.nomineeRelationshipWithLAFemale?.[0][journeyState?.nomineeDataSecond?.relationship]
        }
    }

    if(dynamicEvent){
        window.dataLayer.push({
            "event" : dynamicEvent,
            "ProductName": "Guaranteed Assured Income",
            "ProductCategory": "Savings",
            "ProductSubCategory": "",
            "ProductCode": "90098",
            "PageType": "Buying Journey",
            "PageName": window.location.href,
            "PolicyType": "NON-ULIP",
            "SectionName": dataLayerLookup?.[journeyId]?.[sectionId]?.sectionName,
            "ClientID": clientId,
            "Source":  sourceParameter ? lookup?.sourceChannelLookup_lowercase?.[0]?.[sourceParameter?.toLowerCase()] : journeyState?.channel ? lookup?.sourceChannelLookup_lowercase?.[0][journeyState?.channel?.toLowerCase()] : "",
            "Usertype": journeyState?.dedupeResult === true ? "Returning User" : "New User",
            "Name": allJourneyData?.lifeAssuredDetails?.fullName ? allJourneyData?.lifeAssuredDetails?.fullName?.trim() : "n/a",
            "MobileNumber": allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo ? CryptoJS.MD5(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo)?.toString() : "n/a",
            "EmailID": allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId ? CryptoJS.MD5(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId.toLowerCase())?.toString() : "n/a",
            'userMob' : allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo ?  CryptoJS.SHA256(`${allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCode}${allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo}`).toString() : "n/a",
            'userEmailId' : allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId ?  CryptoJS.SHA256(`${allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId.toLowerCase()}`).toString() : "n/a",
            "mobile_hash": allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo ? btoa(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo) : "",
            "emailID_hash": allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId ? btoa(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId?.toLowerCase()) : "",
            "Gender": allJourneyData?.lifeAssuredDetails?.gender ? lookup?.["gender"]?.[0][allJourneyData?.lifeAssuredDetails?.gender] : "n/a",
            "DOB": allJourneyData?.lifeAssuredDetails?.dob ? moment.unix(allJourneyData?.lifeAssuredDetails?.dob).format('MM/YYYY') : "n/a",
            "Age": allJourneyData?.lifeAssuredDetails?.dob ? getAge(allJourneyData?.lifeAssuredDetails?.dob) : "n/a",
            "City": allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.cityMap ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.cityMap : "n/a",
            "TobaccoConsumer": allJourneyData?.lifeAssuredDetails?.personalDetails?.smoking ? lookup?.["yesNo"][0][allJourneyData?.lifeAssuredDetails?.personalDetails?.smoking] : "n/a",
            "Education": allJourneyData?.lifeAssuredDetails?.employmentDetails?.education ? lookup?.["education"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.education] : "n/a",
            "AnnualIncome": allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome ? Number(allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome) : "n/a",
            "ApplicationNumber": allJourneyData?.basicDetails?.applicationNumber ? allJourneyData?.basicDetails?.applicationNumber : "n/a",
            "SumAssured": allJourneyData?.productDetails?.sumAssured ? allJourneyData?.productDetails?.sumAssured : 'n/a',
            "DefermentPeriod" : allJourneyData?.productDetails?.defermentPeriod ? lookup?.["GAINDefermentPeriod"]?.[0][allJourneyData?.productDetails?.defermentPeriod] : "n/a",
            "IncomePayoutPeriod" : allJourneyData?.productDetails?.incomePeriod ? lookup?.["policyTerm"]?.[0][removeLeadingZeros(allJourneyData?.productDetails?.incomePeriod)] : "n/a",
            "Term": allJourneyData?.productDetails?.policyTerm ? Number(allJourneyData?.productDetails?.policyTerm) : "n/a",
            "PremiumPaymentTerm": allJourneyData?.productDetails?.premiumPaymentTerm ? allJourneyData?.productDetails?.premiumPaymentTerm : "n/a",
            "PaymentFrequency": allJourneyData?.productDetails?.premiumFrequency ? lookup?.["premiumFrequency"][0][allJourneyData?.productDetails?.premiumFrequency] : "n/a",
            "IncomeFrequency" : allJourneyData?.productDetails?.incomeFrequency ? lookup?.["GAINIncomeFrequency"][0][allJourneyData?.productDetails?.incomeFrequency] : "n/a",
            "Premium": allJourneyData?.productDetails?.installmentPremium ? Number(allJourneyData?.productDetails?.installmentPremium)  : "n/a",
            "TotalPremium": journeyState?.premium ? Number(journeyState?.premium) : "n/a",
            "StepUpIncome" : allJourneyData?.productDetails?.stepUpIncomeInd ? allJourneyData?.productDetails?.stepUpIncomeInd : "n/a",
            "Country": allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap ? lookup?.["countryCodeToCountry"]?.[0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap] : "n/a",
            "ResidentialStatus": allJourneyData?.lifeAssuredDetails?.residentStatus ? lookup?.["residentStatus"][0][allJourneyData?.lifeAssuredDetails?.residentStatus] : "n/a",
            "PinCode": allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.pinCode ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.pinCode : "n/a",
            "State": allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.state ? lookup?.["state"][0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.state] : "n/a",
            "Occupation": allJourneyData?.lifeAssuredDetails?.employmentDetails?.occupation ? lookup?.["occupation"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.occupation] : "n/a",
            "NatureOfDuties": allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation ? lookup?.["natureOfOccupation"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation] : "n/a",
            "PlanOption": allJourneyData?.productDetails?.planOption ? lookup?.["planOption"]?.[0][allJourneyData?.productDetails?.planOption] : "n/a",
            "PaymentMode": journeyState?.paymentDecryptData?.paymentMethod ? journeyState?.paymentDecryptData?.paymentMethod : "n/a",
            "NatureOfIndustry": allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry ? lookup?.["natureOfIndustry"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry] : "n/a",
            "NomineeDOB": allJourneyData?.nominees?.[0]?.dob ? moment.unix(allJourneyData?.nominees?.[0]?.dob).format('MM/YYYY') : journeyState?.nomineeDataSecond?.dob ? moment.unix(journeyState?.nomineeDataSecond?.dob).format('MM/YYYY') : "n/a",
            "NomineeRelationship": nomineeRelationship,
            "NomineeGender": allJourneyData?.nominees?.[0]?.gender ? lookup?.gender?.[0][allJourneyData?.nominees?.[0]?.gender] : journeyState?.nomineeDataSecond?.gender ? lookup?.gender?.[0][journeyState.nomineeDataSecond.gender] : "n/a",
            "NomineeEmail": allJourneyData?.nominees?.[0]?.emailId ? CryptoJS.MD5(allJourneyData?.nominees?.[0]?.emailId?.toLowerCase())?.toString() : "n/a",
            "ExistingSumAssured": allJourneyData?.lifeAssuredDetails?.preInsuranceDetails?.insuranceDetails?.[0]?.sumAssured ? allJourneyData?.lifeAssuredDetails?.preInsuranceDetails?.insuranceDetails?.[0]?.sumAssured : "n/a",
            "IsStaffMember": allJourneyData?.lifeAssuredDetails?.employmentDetails?.staff === 'Y' ? 'Yes' : allJourneyData?.lifeAssuredDetails?.employmentDetails?.staff === 'N' ? 'No' : 'n/a',
            "InsuranceRepository": allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.insuranceRepository ? lookup?.["insuranceRepository"]?.[0][allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.insuranceRepository] : "n/a",
            "PaymentOption": paymentOption,
            "order_ID": journeyState?.paymentDecryptData?.paymentTxnId ? journeyState?.paymentDecryptData?.paymentTxnId : "n/a",
            'NachStatus': (allJourneyData?.basicDetails?.enachSuccess === true) ? "Success" : (allJourneyData?.basicDetails?.enachSuccess === false ? "Fail" : "n/a"),
            'NachType': (allJourneyData?.basicDetails?.isPhysicalMandateOpt === true) ? "Physical Mandate" : (allJourneyData?.basicDetails?.isPhysicalMandateOpt === false ? "E-Mandate" : "n/a"),
            'IsProposerSame' : allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === 'Y' ? 'Yes' : allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === 'N' ? 'No' : 'n/a',
        })
    }
}

export function gainTransactionDataLayer (allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyState) {
    const emailID = allJourneyDataResponse?.journeyData?.basicDetails?.emailID;
    const mobileNo = allJourneyDataResponse?.journeyData?.basicDetails?.mobileNo;
    let encryptedEmail 
    let encryptedMobileNo
    try {
      encryptedEmail = CryptoJS.MD5(emailID?.toLowerCase())?.toString();
      console.log(encryptedEmail, "encryptedEmail")
      encryptedMobileNo = CryptoJS.MD5(mobileNo)?.toString();
      console.log(encryptedMobileNo, "encryptedMobileNo")
    }catch(err){
      console.log(err, "dsds")
    }
    
    const transactions = allJourneyDataResponse?.journeyData?.transactionDetails?.transactions
    
    var products = [];
    products.push({
      'name': 'Guaranteed Assured Income',
      'id': '90098',                            
      'category': 'Savings',                     
      'price': allJourneyDataResponse?.journeyData?.premium,                 
      'quantity': '1'                        
    })

    var items = [];
    items.push({
        'item_id': "90098", 
        'item_name': "Guaranteed Assured Income",
        'currency': "INR",
        'item_brand': "CanaraHSBC",
        'item_category': "Savings", 
        'item_category2': "", 
        'price': Number(allJourneyDataResponse?.journeyData?.premium), 
        'quantity': 1
    })

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': "purchase",
        'ecommerce': {
            'transaction_id': transactions?.[transactions.length -1]?.paymentTxnId, 
            'affiliation': lookup?.sourceChannelLookup_lowercase?.[0][allJourneyDataResponse?.journeyData?.basicDetails?.channel?.toLowerCase()],
            'value': Number(allJourneyDataResponse?.journeyData?.premium), 
            'tax': 'n/a', 
            'currency': "INR",
            'coupon': "", 
            'discount': 0,
            'payment_type': transactions?.[transactions.length -1]?.paymentMethod,
            'items': items
        }
    })
}